import mixpanel from 'mixpanel-browser';
import { getUtmParameters, getIpInfo } from '@/utils';

export default {
  install(Vue) {
    const MIXPANEL_TOKEN =
      process.env.VUE_APP_TARGET === 'campaign'
        ? process.env.VUE_APP_SUPERCHART_MIXPANEL_TOKEN
        : process.env.VUE_APP_SUPERMEMBERS_MIXPANEL_TOKEN;

    const initMixpanel = async () => {
      if (!MIXPANEL_TOKEN) return;

      try {
        mixpanel.init(MIXPANEL_TOKEN, {
          debug: true, // MIXPANEL이 잘 초기화 되었는지 console.log로 확인할 수 있음
          persistence: 'localStorage',
        });
      } catch (error) {
        console.error('Mixpanel 초기화 실패:', error);
      }
    };

    const updateMixpanelUserProperties = async (user = {}) => {
      if (!MIXPANEL_TOKEN || !mixpanel) return;

      // NOTE: 비로그인 상태에서 identify 호출 X

      if (user?.companyId) {
        mixpanel.identify(user.companyId);
      }

      const utmParams = getUtmParameters();
      const ip = await getIpInfo();

      const properties = {
        service: process.env.VUE_APP_TARGET === 'campaign' ? 'superchart' : 'supermembers',
        userId: user.companyId,
        clientAccessTime: new Date().toISOString(),
        createdAt: user.createdAt,
        agreeToMarketing: user.agree_to_mail,
        isMember: true,
        isStaff: user.is_staff ? true : false,
        companyName: user.name,
        ip,
        ...utmParams,
      };

      mixpanel.register(properties);
    };

    const updateMixpanelAdProperties = (ad = {}) => {
      const properties = {
        adId: ad.id,
        adName: ad.name,
        adType: ad.type,
        adCategory: ad.category?.first,
        midCategory: ad.category?.second,
        bottomCategory: ad.category?.third,
        regionCompany: ad.localCode_region,
        localCompany: ad.localCode_local,
      };

      mixpanel.register(properties);
    };

    const resetMixpanelCommonProperties = () => {
      if (!MIXPANEL_TOKEN || !mixpanel) return;
      mixpanel.reset();
    };

    const Mixpanel = {
      async trackSuperchartEvent(eventName, properties = {}) {
        if (!MIXPANEL_TOKEN || !mixpanel) return;

        try {
          const mergedProps = { ...properties, service: 'superchart' };

          mixpanel.track(eventName, mergedProps);
        } catch (error) {
          console.error('Mixpanel 이벤트 추적 실패:', error);
        }
      },

      get mixpanel() {
        return MIXPANEL_TOKEN ? mixpanel : null;
      },
    };

    initMixpanel();

    window.mixpanel = Mixpanel; // GTM에서 접근할 수 있도록 전역 객체로 노출

    Vue.prototype.$mixpanel = Mixpanel;
    Vue.prototype.updateMixpanelUserProperties = updateMixpanelUserProperties;
    Vue.prototype.updateMixpanelAdProperties = updateMixpanelAdProperties;
    Vue.prototype.resetMixpanelCommonProperties = resetMixpanelCommonProperties;
  },
};
